import { runEvalScript } from "../helpers/runEvalScritp";

export async function listCompositions(){
  return await runEvalScript("$._blingsio.dataManager.getCompositions()");
}